var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.stripeAccount)?_c('CreateAccount'):_c('Account',{ref:"account"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }